import React from 'react';
// import { Link } from 'react-router-dom';
// import logo from '../../assets/logo.png';

const Footer = () => {
	return (
		<footer className="text-gray-700 body-font">
			<div className="container px-5 py-3 mx-auto flex items-center sm:flex-row flex-col">
				<p className="text-sm text-gray-500 sm:ml-4 sm:pl-4 sm:py-2 sm:mt-0 mt-4">© محصولی از شرکت برنامه نویسان دانش برتر سهند V{localStorage.getItem('version')}</p>
				
			</div>
		</footer>
	);
};

export default Footer;
